export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconClasses: ['font-icon', 'font-icon-dashboard'],
            iconClass: 'material-icons',
            iconName: 'dashboard',
            color: 'navy',
        },
        {
            name: 'Content',
            children: [
                { name: 'Layouts', route: 'layouts', shortcut: 'layout/_' },
                { name: 'Pages', route: 'pages', type: 'page', shortcut: 'page/_' },
                { name: 'Panel library', route: 'panels', type: 'panel', shortcut: 'panel/_' },
            ],
            iconClass: 'material-icons',
            iconName: 'content_copy',
            color: 'navy',
        },
        {
            name: 'Assets',
            route: 'assets',
            type: 'asset',
            iconClass: 'material-icons',
            iconName: 'photo_album',
            color: 'navy',
        },
        {

            name: 'News',
            children: [
                { name: 'Posts', route: 'news_posts', type: 'news_post' },
                { name: 'Categories', route: 'news_categories', type: 'news_category' },
            ],
            iconClass: 'material-icons',
            iconName: 'perm_media',
            color: 'navy',
        },
        // {
        //     name: 'Sales Support',
        //     children: [
        //         { name: 'Projects', route: 'projects', type: 'project', shortcut: 'project/_' },
        //         { name: 'Attributes', route: 'attributes', type: 'attribute', shortcut: 'attributes/_' },
        //     ],
        //     iconClass: 'material-icons',
        //     iconName: 'assignment',
        //     color: 'navy',
        // },
        {
            name: 'Sales Support',
            children: [
                { name: 'Buildings', route: 'buildings', type: 'building' },
                { name: 'Building Levels', route: 'building_levels', type: 'building_level' },
                { name: 'Building Units', route: 'building_units', type: 'building_unit' },
            ],
            iconClass: 'material-icons',
            iconName: 'store',
            color: 'navy',
        },
        {
            name: 'Team',
            route: 'staff_members',
            iconClass: 'material-icons',
            iconName: 'sentiment_satisfied_alt',
            color: 'navy',
        },
        // {
        //     name: 'Services',
        //     route: 'services',
        //     iconClass: 'material-icons',
        //     iconName: 'devices_other',
        //     color: 'navy',
        // },
        // {
        //     name: 'Products',
        //     children: [
        //         { name: 'Products', route: 'products', type: 'product' },
        //         { name: 'CaseStudies', route: 'case_studies', type: 'case_study' },
        //     ],
        //     iconClass: 'material-icons',
        //     iconName: 'store',
        //     color: 'navy',
        // },
        {
            name: 'Customers',
            type: 'customer',
            route: 'customers',
            iconClass: 'material-icons',
            iconName: 'perm_contact_calendar',
            color: 'navy',
        },
        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
            ],
            iconClass: 'material-icons',
            iconName: 'forum',
            color: 'navy',
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', shortcut: 'user/_', type: 'user' },
                { name: 'Roles', route: 'roles', shortcut: 'role/_', type: 'role' },
            ],
            iconClass: 'material-icons',
            iconName: 'account_box',
            color: 'navy',
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            iconClass: 'material-icons',
            iconName: 'settings',
            color: 'navy',
        }
    ],
    defaultItem: 'Content',
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/menu.js